// Collapsible primary menu items
// const ef_menuCollapseItems = document.getElementsByClassName("ef-primary-menu__items-collapsible");
// const ef_menuCollapseToggle = document.querySelector(".ef-primary-menu__items-toggle");
//
// function _toggleClasses(els, name) {
//   for (let i = 0; i < els.length; i++) {
//     els[i].classList.toggle(name)
//   }
// }
//
// document.addEventListener("click", event => {
//
//   // If the clicked element doesn't have the right selector, bail
//   if (!event.target.matches(".ef-primary-menu__items-toggle, .ef-primary-menu__items-toggle *")) return;
//
//   // Don't follow the link
//   event.preventDefault();
//
//   ef_menuCollapseToggle.classList.toggle("--is-open");
//   _toggleClasses(ef_menuCollapseItems, "--is-open");
//
// }, false);
